<template>
  <div>
    <div v-if="fieldDef.editorType == 'dxSelectBox'">
      <div v-if="fieldDef.editorOptions && fieldDef.editorOptions.relateModule">
        <RelateComponent
          v-model="fieldValue"
          :rRoute="fieldDef.editorOptions.relateModule"
          :slug="prefix"
          v-on:changed="inputChanged()"
        >
        </RelateComponent>
      </div>
      <div v-else>
        <DxSelectBox
          :items="fieldDef.lookup.dataSource"
          v-model="fieldValue"
          value-change-event="keyup"
          @value-changed="inputChanged()"
          :display-expr="fieldDef.lookup.displayExpr"
          :value-expr="fieldDef.lookup.valueExpr"
        />
      </div>
    </div>

    <div v-if="fieldDef.editorType == 'dxTextBox'">
      <DxTextBox
        v-model="fieldValue"
        value-change-event="keyup"
        @value-changed="inputChanged()"
      />
    </div>
    <div v-if="fieldDef.editorType == 'dxNumberBox'">
      <DxNumberBox
        v-model="fieldValue"
        value-change-event="keyup"
        @value-changed="inputChanged()"
      />
    </div>

    <div v-if="fieldDef.editorType == 'dxDateBox'">
      <DxDateBox
        v-model="fieldValue"
        :display-format="fieldDef.editorOptions.displayFormat"
        value-change-event="keyup"
        data-key="birthday"
        @value-changed="handleDateChange"
        @change="dateChangeEvent()"
      />
    </div>
  </div>
</template>

<script>
import DxTextBox from "devextreme-vue/text-box";
import DxNumberBox from "devextreme-vue/number-box";
import DxSelectBox from "devextreme-vue/select-box";

import DxButton from "devextreme-vue/button";
import RelateComponent from "./RelateComponent.vue";
import DxDateBox from "devextreme-vue/date-box";
import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
  DxLabel,
} from "devextreme-vue/form";

export default {
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    onValueChanged: {
      type: Function,
      default: () => function () {},
    },
    onCellPrepared: {
      type: Function,
      default: () => function () {},
    },
    fieldDef: {
      type: Object,
      default: () => ({}),
    },
    prefix: String,
    routeDef: String,
  },
  components: {
    RelateComponent,
    DxSimpleItem,
    DxTextBox,
    DxNumberBox,
    RelateComponent,
    DxDateBox,
    DxSelectBox,
  },
  data: function () {
    return {
      fieldValue: this.item.value,
      index: 0,
    };
  },
  methods: {
    inputChanged(e) {
      console.log("ss", this.item);
      console.log("inputChanged", e);
    },
    dateChangeEvent(e) {
      console.log("dateChangeEvent", e);
    },
  },
  mounted() {
    // console.log("HELLO WORLD!! fieldDef",this.fieldDef);

    if (Object.keys(this.item).length !== 0) {
      this.fieldValue = this.item.value;
    }

    console.log("Watching List item", this.item);

    this.$watch("fieldValue", (newVal, oldVal) => {
      if (
        this.item.column.editorType == "dxDateBox" &&
        this.item.column.userDataType == "date" &&
        newVal instanceof Date &&
        newVal != null
      ) {
        // const formattedDate = newVal
        //   .toLocaleDateString("en-IN", {
        //     year: "numeric",
        //     month: "2-digit",
        //     day: "2-digit",
        //   })
        //   .replace(/\//g, "-");

        const selectedDate = new Date(newVal);
        const year = selectedDate.getFullYear();
        const month = String(selectedDate.getMonth() + 1).padStart(2, "0");
        const day = String(selectedDate.getDate()).padStart(2, "0");
        newVal = `${year}-${month}-${day}`;

        console.log("Date Value", newVal);
      }
      console.log("Watching fieldValue", newVal);

      this.$emit("field-value-changed", newVal);

      this.onValueChanged(newVal);
      //this.onCellPrepared(newVal);

      //this.$emit('update:modelValue', newVal);
    });
  },
};
</script>

<style>
</style>